import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { Button, useNotify, useRefresh, useUpdate } from 'react-admin';
import { DataProviderResource } from 'src/constants';

interface ResetFailedAccountAttemptsButtonProps {
  id: string;
  failedCreateAttempts?: boolean;
  failedLinkAttempts?: boolean;
}

export const ResetFailedAccountAttemptsButton = ({
  id,
  failedCreateAttempts,
  failedLinkAttempts,
}: ResetFailedAccountAttemptsButtonProps) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const [update, { isLoading }] = useUpdate();

  const onReset = async () => {
    update(
      DataProviderResource.ResetAccountAttempts,
      {
        id,
        data: {
          failedCreateAttempts,
          failedLinkAttempts,
        },
      },
      {
        onSuccess: () => {
          notify('Failed account attempts were successfully reset.', { type: 'success' });
        },
        onSettled: () => {
          refresh();
        },
        onError: err => {
          notify(`Failed account attempts reset error: ${err}`, {
            type: 'error',
          });
        },
      },
    );
  };

  return (
    <Button label={'Reset'} onClick={onReset} disabled={isLoading} style={{ marginTop: '8px' }}>
      <RestartAltIcon />
    </Button>
  );
};
